import { categorySchema, type Category } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postArchive = (id: string): Promise<unknown> =>
  apiRequest<unknown>(`/categories/${id}/archive`, { method: 'POST' });

export const archiveCategory = async (id: string): Promise<Category> =>
  categorySchema.parse(await postArchive(id));
